import React, { useRef, useState } from 'react';
import { Image } from '@mui/icons-material';
import { Box, Button, FormControl, FormHelperText, IconButton, Input, InputLabel } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

type UploadFilePropsType = {
  value: string | File | null | undefined;
  onChange: (...event: any[]) => void;
  textLabel: string;
  helperText: string;
  textButton: string;
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
};

export const UploadImage = ({ value, onChange, textLabel, helperText, textButton, errors }: UploadFilePropsType) => {
  const defaultImage = typeof value === 'string' ? value : null;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
    onChange(file);
    event.target.value = '';
  };

  const handleImageUpload = () => {
    inputRef.current?.click();
  };

  const handleRemoveFile = () => {
    onChange(null);
    setSelectedFile(null);
  };

  return (
    <Box mt={2}>
      <Input
        type="file"
        inputRef={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
      {selectedFile || defaultImage ? (
        <FormControl
          fullWidth
          sx={{}}
        >
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '10px',
              position: 'relative',
            }}
          >
            <InputLabel
              sx={{
                position: 'absolute',
                top: '-22px',
                background: '#fff',
                padding: '0 4px',
                left: '-7px',
              }}
              size="small"
            >
              {textLabel}
            </InputLabel>

            {defaultImage ? (
              <img
                src={defaultImage}
                alt="Selected"
                style={{ maxWidth: '100px', maxHeight: '100px' }}
              />
            ) : (
              <img
                src={URL.createObjectURL(selectedFile as File)}
                alt="Selected"
                style={{ maxWidth: '100px', maxHeight: '100px' }}
              />
            )}

            <IconButton
              onClick={handleRemoveFile}
              size="small"
            >
              <CancelIcon />
            </IconButton>
          </Box>
          <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
      ) : (
        <>
          <Button
            color={errors && 'error'}
            variant="contained"
            startIcon={<Image />}
            onClick={handleImageUpload}
          >
            {textButton}
          </Button>
          {errors && <FormHelperText error>{errors.message?.toString()}</FormHelperText>}
        </>
      )}
    </Box>
  );
};
